import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";

function coachContact(agentId = "", data = {}) {
    let formData = new FormData();

    if (agentId != "") {
        formData.append("agentId", agentId);
    } else {
        formData.append("headquarter", true);
    }

    for (let key in data) {
        formData.append(key, data[key]);
    }

    return axios.post("?Mode=General&Function=Kontakt", formData);
}

function videoCallGenerate(data) {
    const dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=VideoCallGenerate",
        dataString
    );
}

function videoCallGetRoom(chatid) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=VideoCallGetRoom",
        "chatid=" + chatid
    );
}

export { coachContact, videoCallGenerate, videoCallGetRoom };
